import { render, staticRenderFns } from "./ViewBordereauDetailsModal.vue?vue&type=template&id=a9a7cd0a&scoped=true&"
import script from "./ViewBordereauDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewBordereauDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewBordereauDetailsModal.vue?vue&type=style&index=0&id=a9a7cd0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a7cd0a",
  null
  
)

export default component.exports